import {useCallback, useEffect, useState} from 'react';
import {useMounted} from '../use-mounted';
import {masterDataAPI} from 'src/api/master-data-service';

export const UseListOptions = () => {
    const isMounted = useMounted();

    const [state, setState] = useState({
        listOptions: [],
    });

    const clearListOption = () => {
        console.log("this.clear")
        localStorage.removeItem('listOptions')
    }

    const handleGetListOptionData = useCallback(async () => {
        try {
            const listOptionsLocal = JSON.parse(localStorage.getItem('listOptions'));
            let temp;

            if (!listOptionsLocal) {
                // FIXME !!!
                const response = await masterDataAPI.getListOptions();

                if (response && response.listOptions) {
                    let temp_key = Object.keys(response.listOptions);
                    temp_key.map((item, index) => {
                        temp = {
                            ...temp,
                            [item]: response.listOptions[item] ?? []
                        };
                    });

                }
                temp = {
                    ...temp,
                    'opt_cmp_arrive': list_cmp_arrive ?? [],
                    'opt_service_type': list_service_type ?? [],
                    'opt_list_zone': list_zone ?? [],
                    'opt_list_policy_coverage': list_policy_coverage ?? [],
                    'list_contact_type': list_contact_type ?? [],
                    'list_injury_type': list_injury_type ?? [],
                };
                localStorage.setItem('listOptions', JSON.stringify(temp));
            } else {
                temp = listOptionsLocal
            }

            if (isMounted()) {
                setState({listOptions: temp});
            }
        } catch (err) {
            console.error(err);
        }
    }, [isMounted]);

    const fetchListOption = useCallback(async () => {
        try {
            await clearListOption()
            if (isMounted()) {
                return handleGetListOptionData()
            }
        } catch (err) {
            console.error(err);
        }
    }, [isMounted]);


    useEffect(() => {
        handleGetListOptionData();
    }, []);

    return {
        ...state,
        handleGetListOptionData,
        fetchListOption
    };
};
export const list_cmp_arrive = [
    {
        value: 'before',
        label: 'เร็วกว่าคู่กรณี'
    },
    {
        value: 'after',
        label: 'ช้ากว่าคู่กรณี'
    },
    {
        value: 'พร้อมกับคู่กรณี',
        label: 'พร้อมกับคู่กรณี'
    },
]
export const list_service_type = [
    {
        value: 'บริการ',
        label: 'บริการ'
    },
    {
        value: 'ต่อเนื่อง',
        label: 'ต่อเนื่อง'
    },
    {
        value: 'หน้าร้าน',
        label: 'หน้าร้าน'
    },
    {
        value: 'พิกัดเดียวกัน',
        label: 'พิกัดเดียวกัน'
    },
]
export const list_zone = [
    {
        value: 'กทม',
        label: 'กทม'
    },
    {
        value: 'ปริมณฑล',
        label: 'ปริมณฑล'
    },
    {
        value: 'ตจว.',
        label: 'ตจว.'
    },
]
export const list_policy_coverage = [
    {
        value: 'คุ้มครอง',
        label: 'รับผิดชอบรถประกันได้'
    },
    {
        value: 'ไม่คุ้มครอง',
        label: 'ไม่รับผิดชอบ'
    },
    {
        value: 'รอตรวจสอบ',
        label: 'รอตรวจสอบ'
    },
]
export const list_contact_type = [
    {label:"พนักงาน",value:"พนักงาน"},
    {label:"ลูกค้า",value:"ลูกค้า"}
]
export const list_injury_type = [
    {
        value: 'd',
        label: 'เสียชีวิต'
    },
    {
        value: 'i',
        label: 'บาดเจ็บ'
    },

]